import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { MD_DIALOG_DATA, MdDialogRef } from '@angular/material';
import { CompanyCommunication } from 'app/model/user/communication-preference.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilitiesService } from 'app/services/utilities/utilities.service';

@Component({
  selector: 'act-dialog-company-communication-banner',
  templateUrl: './dialog-company-communication-banner.component.html',
  styleUrls: ['./dialog-company-communication-banner.component.scss']
})
export class DialogCompanyCommunicationBannerComponent implements OnInit {
  public form: FormGroup;
  public isValidFormSubmitted = null;
  public dialogWidthDesktop = 750;
  public dialogHeightMobile = 640;
  public dialogMaxWidthMobile = 430;

  public image: any;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: CompanyCommunication,
    public dialogRef: MdDialogRef<DialogCompanyCommunicationBannerComponent>,
    private utilitiesService: UtilitiesService
  ) {
    this.buildForm();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.resizeDialog();
    document.documentElement.style.setProperty('--height-vh', `${window.innerHeight * 0.01}px`);
  }

  ngOnInit() {
    this.resizeDialog();
    this.image = `data:image/jpeg;base64,${btoa(new Uint8Array(this.data.bannerTemplate.bannerImage).reduce((data, byte) => data + String.fromCharCode(byte), ''))}`;
  }

  resizeDialog() {
    if (!this.utilitiesService.isMobile()) {
      this.resizeDialogDesktopSize();
    } else {
      this.resizeDialogMobileSize();
    }
  }

  resizeDialogMobileSize() {
    const dialogWidthMobile = (window.innerWidth - 20);
    this.dialogHeightMobile = dialogWidthMobile * (640 / 480);
    if (this.data.acceptingCondition) {
      this.dialogMaxWidthMobile = 540
    } else {
      this.dialogMaxWidthMobile = Math.max((window.innerHeight - 70) * (480 / 640), 200)
    }
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.maxWidth = `${this.dialogMaxWidthMobile}px`;
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.marginLeft = `auto`;
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.marginRight = `auto`;
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.marginTop = `-50px`;
  }

  resizeDialogDesktopSize() {
    if (window.innerHeight < 680) {
      this.dialogWidthDesktop = Math.max(750 - (680 - window.innerHeight) * (750 / 600), 200);
      (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.width = `${this.dialogWidthDesktop}px`;
    } else {
      this.dialogWidthDesktop = 750;
      (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.width = `${this.dialogWidthDesktop}px`;
    }
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.maxWidth = `unset`;
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.marginLeft = `unset`;
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.marginRight = `unset`;
    (document.getElementsByClassName('dialog-wrapper-content')[0] as HTMLElement).style.marginTop = `unset`;
  }

  buildForm() {
    this.form = new FormGroup({
      agree: new FormControl('', Validators.requiredTrue)
    });
  }

  onFormSubmit() {
    this.isValidFormSubmitted = false;
    if (this.data.acceptingCondition && (this.form.invalid)) {
      return;
    }
    this.isValidFormSubmitted = true;
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modal/dialog-company-communication-banner/dialog-company-communication-banner.component.ts